import React from 'react';

const NoMatch = () => {
    return (
        <div styles={{ textAlign: 'center' }}>
            <h2>404 || Not Found</h2>
        </div>
    );
};

export default NoMatch;